'use client';

import clsx from 'clsx';
import { useState } from 'react';

import styles from '../../ImageLink.module.scss';

import { Icon, Typography } from '@/components/core';

type CardActionProps = {
    title: string;
};

export const CardActionClient = ({ title }: CardActionProps) => {
    const [lightPosition, setLightPosition] = useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = useState(false);
    const [arrowAnimation, setArrowAnimation] = useState(false);

    const handleMouseMove = (e: React.MouseEvent) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setLightPosition({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    const handleMouseEnter = () => {
        setArrowAnimation(true);
        setIsHovering(true);
        setTimeout(() => {
            setArrowAnimation(false);
        }, 600);
    };

    return (
        <div
            onMouseMove={handleMouseMove}
            onMouseLeave={() => setIsHovering(false)}
            onMouseEnter={handleMouseEnter}
            className={styles.action}
        >
            <div
                className={clsx(styles.lightEffect, { [styles.isHovering]: isHovering })}
                style={{
                    left: `${lightPosition.x}px`,
                    top: `${lightPosition.y}px`,
                }}
            />
            <div className={styles.titleWrapper}>
                <Typography as="h4">{title}</Typography>
            </div>
            <div className={clsx(styles.icon, { [styles.animate]: arrowAnimation })}>
                <Icon name="longArrow" />
            </div>
        </div>
    );
};
